import { APIClient } from "./api_helper";

import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// //is user is logged in
export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Resync
export const postResync = (data : any) => api.create(url.POST_RESYNC, data);

// Login
export const postLogin = (data : any) => api.create(url.POST_LOGIN, data);
// get Apps
export const getAppsData = () => api.get(url.GET_APPS);

// Logout
export const logout = () => api.get(url.LOGOUT);
